import * as XLSX from "xlsx";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

const ExcelExport = ({
  data,
  columns,
  fileName = "report.xlsx",
  reportFilters = {},
  reportTitle = "Report",
}) => {

  const generateExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    /* =============================
       1️⃣ BUILD FILTER HEADER ROW
    ============================== */
    const filterRow = [];

    const addFilter = (label, value) => {
      if (value && value !== "All") {
        filterRow.push(`${label}: ${value}`);
      }
    };

    addFilter("From Date", reportFilters.fromDate);
    addFilter("To Date", reportFilters.toDate);
    addFilter("Month", reportFilters.month);
    addFilter("Year", reportFilters.year);

    if (filterRow.length === 0) {
      filterRow.push(
        reportTitle || fileName.replace(".xlsx", "").replaceAll("_", " ")
      );
    }

    /* =============================
       2️⃣ TABLE HEADER
    ============================== */
    const tableHeader = columns.map(col => col.header);

    /* =============================
       3️⃣ TABLE DATA  (already filtered — whatever was passed in `data`)
    ============================== */
    const tableData = data.map(row =>
      columns.map(col => {
        let value = row[col.key];

        if (value === null || value === undefined) return "";

        if (col.type === "text") return String(value);
        if (col.type === "number") return Number(value || 0);

        return value;
      })
    );

    /* =============================
       4️⃣ FINAL SHEET STRUCTURE
    ============================== */
    const sheetData = [
      filterRow,
      [],
      tableHeader,
      ...tableData,
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    /* =============================
       5️⃣ FORCE TEXT COLUMN TYPE
    ============================== */
    columns.forEach((col, colIndex) => {
      if (col.type === "text") {
        tableData.forEach((row, rowIndex) => {
          const cellAddress = XLSX.utils.encode_cell({
            r: rowIndex + 3, // offset for header rows
            c: colIndex,
          });
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].t = "s";
            worksheet[cellAddress].v = String(worksheet[cellAddress].v ?? "");
          }
        });
      }
    });

    /* =============================
       6️⃣ FORMAT NUMBER COLUMNS
    ============================== */
    Object.keys(worksheet).forEach(cell => {
      if (worksheet[cell]?.t === "n") {
        worksheet[cell].z = "0.00";
      }
    });

    /* =============================
       7️⃣ AUTO COLUMN WIDTH
    ============================== */
    worksheet["!cols"] = columns.map(col => ({
      wch: Math.max(col.header.length + 4, 18),
    }));

    /* =============================
       8️⃣ CREATE WORKBOOK
    ============================== */
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    XLSX.writeFile(workbook, fileName);
  };

  /* ── Button: dark violetstyle matching TaskManagementPage ─────────────── */
  return (
    <button
      onClick={generateExcel}
      title={`Export ${data?.length ?? 0} filtered row(s) to Excel`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "9px 12px",          
        borderRadius: "0.5rem",
        background: "linear-gradient(135deg, #059669, #10b981)",
        color: "#fff",
        fontSize: "0.75rem",          
        fontWeight: 600,             
        border: "none",
        cursor: "pointer",
        transition: "opacity 0.15s",
        whiteSpace: "nowrap",
      }}
      onMouseOver={(e) => (e.currentTarget.style.opacity = "0.85")}
      onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <ArrowDownTrayIcon style={{ width: 13, height: 13 }} /> 
      Export

      {data?.length > 0 && (
        <span style={{
          background: "rgba(255,255,255,0.22)",
          borderRadius: "9999px",
          padding: "1px 6px",         
          fontSize: "0.65rem",
          fontWeight: 700,
          marginLeft: 2,
        }}>
          {data.length}
        </span>
      )}
    </button>
  );
};

export default ExcelExport;